/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { Fragment } from 'react';

import { isolateComponent } from '@zapier/common-utils';

import {
  Radio,
  FormLabel,
  Margin,
  Spacer,
  Surface,
  Text,
} from '@zapier/design-system';

import { Interval, Price } from '@zapier/design-system-revenue';

import { FancyPrice } from './FancyPrice';

type Props = {
  /** The total billed amount for this interval */
  amount: number;
  interval: Interval;
  isSelected: boolean;
  onSelect: () => void;
};

const labelStyles = css`
  text-transform: capitalize;
`;

export const BillingIntervalOption = ({
  amount,
  interval,
  isSelected,
  onSelect,
}: Props) => {
  const monthlyAmount = interval === 'year' ? amount / 12 : amount;

  return (
    <Fragment>
      <FormLabel layout="auto-content">
        <Radio
          checked={isSelected}
          name="billing-interval-radio"
          onChange={onSelect}
          value={interval}
        />
        <span css={labelStyles}>Pay {interval}ly</span>
      </FormLabel>

      <Spacer height={5} />

      <Surface backgroundColor="grey000" borderColor="grey200">
        <Margin margin={20}>
          <FancyPrice>{monthlyAmount}</FancyPrice>

          <Text color="grey700" type="altText800">
            per month /{' '}
            {interval === 'year' ? (
              <Fragment>
                <Price>{amount}</Price> per year
              </Fragment>
            ) : (
              'month-to-month'
            )}
          </Text>
        </Margin>
      </Surface>
    </Fragment>
  );
};
